import { VisionApplication } from '../../application';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';
import { PreventativeMaintenanceTab } from './pm';
import { PMWorkFilesWindow } from './pm_files';
import { PMDTO, PMWork } from './pmservice';

export class PMWindow extends VisionWindow {
    //[x: string]: any;
    layout!: dhtmlXLayoutObject;
    form!: dhtmlXForm;
    workGrid!: dhtmlXGridObject;
    pmToolbar!: dhtmlXToolbarObject;
    workToolbar!: dhtmlXToolbarObject;
    tab: PreventativeMaintenanceTab;
    activePM!: PMDTO;

    constructor(manager: VisionWindowManager, tab: PreventativeMaintenanceTab) {
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.45;
        super(manager, {
            id: 'complete_pm_window',
            title: 'Complete PM',
            x: 30,
            y: 30,
            width: width,
            height: height,
        });
        this.window.setText('PM');
        this.tab = tab;

        this.manager.win.window('complete_pm_window').attachEvent('onClose', () => {
            this.visible = false;
            this.tab.editPMWindow = undefined;
            return true;
        });

        const formData = [
            {
                type: 'fieldset',
                name: 'login_info',
                label: 'Vehicle Info',
                width: 300,
                offsetLeft: '25',
                list: [
                    {
                        name: 'asset',
                        type: 'input',
                        label: 'Vehicle',
                        value: '',
                        inputWidth: '150',
                        offsetLeft: '5',
                        offsetTop: '5',
                        disabled: true,
                    },
                    {
                        name: 'pm_name',
                        type: 'input',
                        label: 'PM Name',
                        value: '',
                        inputWidth: '150',
                        offsetLeft: '5',
                        offsetTop: '5',
                        disabled: false,
                    },
                    /*
                {name: "pm_odometer", type: "input", label: "Odometer", value: "", inputWidth: "150", offsetLeft: "5", offsetTop: "5", disabled: false},
                {name: "pm_hours", type: "input", label: "Hours", value: "", inputWidth: "150", offsetLeft: "5", offsetTop: "5", disabled: false},
                {name: "pm_due_odometer", type: "input", label: "Due Odometer", value: "", inputWidth: "150", offsetLeft: "5", offsetTop: "5", disabled: false},
                {name: "pm_due_hours", type: "input", label: "Due Hours", value: "", inputWidth: "150", offsetLeft: "5", offsetTop: "5", disabled: false}
                */
                ],
            },
        ];

        this.layout = this.window.attachLayout('2E');
        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();

        this.form = this.layout.cells('a').attachForm(formData);

        this.workGrid = this.layout.cells('b').attachGrid();
        this.workGrid.setHeader('Date,Description,Cost', '', []);
        this.workGrid.setColTypes('dhxCalendarA,txt,price');
        this.workGrid.init();

        this.pmToolbar = this.layout.cells('a').attachToolbar();
        this.pmToolbar.addButton('complete', 0, 'Complete PM', 'css/imgs/new.gif', '');
        this.pmToolbar.addButton('save', 1, 'Update PM', 'css/imgs/save.gif', '');

        this.workToolbar = this.layout.cells('b').attachToolbar();
        this.workToolbar.addButton('add', 0, 'Work Item', 'icons/sign.png', '');
        this.workToolbar.addButton('delete', 1, 'Work Item', 'icons/clear.png', '');

        this.setupEventHandlers();
    }

    public setPM(id: string) {
        this.tab.service.cachedFetchData().then((data) => {
            const idx = data.findIndex((i) => i.id === id);
            const pm = data[idx];
            this.activePM = pm;

            const assetName = VisionApplication.getInstance().assetService.assetList.get(data[idx].assetId)?.id.name;
            this.form.setItemValue('asset', assetName);
            this.form.setItemValue('pm_name', pm.name);

            this.window.setText(pm.name + ' on ' + assetName);

            this.workGrid.clearAll(false);

            pm.work.forEach((workitem) => {
                const workdata = [];
                workdata.push(workitem.date);
                workdata.push(workitem.description);
                workdata.push(workitem.cost);
                this.workGrid.addRow(workitem.id, workdata, 0, '', '', false);
            });
        });
    }

    private setupEventHandlers(): void {
        this.workToolbar.attachEvent('onClick', (id) => {
            this.workToolbarHandler(id);
        });
        this.workGrid.attachEvent('onRowSelect', (rid, cid) => {
            this.workGridHandler(rid, cid);
        });
        this.pmToolbar.attachEvent('onClick', (itemId) => {
            this.pmToolbarHandler(itemId);
        });
    }

    private workGridHandler(rid: string, cid: string | number) {
        if (cid == 3) {
            //const window = new PMWorkFilesWindow(rid, this.tab.service);
            new PMWorkFilesWindow(rid, this.tab.service);
        }
    }

    private pmToolbarHandler(id: string): void {
        const result = Array<PMWork>();

        if (id == 'save') {
            const ids = this.workGrid.getAllRowIds(',').split(',');

            ids.forEach((rowId) => {
                console.log('Row: ' + rowId);
                const workItem = {} as PMWork;
                workItem.id = rowId;
                workItem.date = this.workGrid.cells(rowId, 0).getValue();
                workItem.description = this.workGrid.cells(rowId, 1).getValue();
                workItem.cost = Number(this.workGrid.cells(rowId, 2).getValue());
                result.push(workItem);
            });

            this.tab.service.updateWork(this.activePM.id, result).then((_result) => {
                dhtmlx.message({
                    title: 'Save Complete',
                    text: 'Active PM Updated.',
                    type: 'alert-success',
                });
            });
        } else if (id == 'complete') {
            this.workGrid.forEachRow((rowId) => {
                const workItem = {} as PMWork;
                workItem.id = rowId;
                workItem.date = this.workGrid.cells(rowId, 0).getValue();
                workItem.description = this.workGrid.cells(rowId, 1).getValue();
                workItem.cost = Number(this.workGrid.cells(rowId, 2).getValue());
                result.push(workItem);
            });

            this.tab.service.completePM(this.activePM.id, result).then((_result) => {
                dhtmlx.message({
                    title: 'Complete',
                    text: 'PM Was Completed.',
                    type: 'alert-success',
                    callback: () => {
                        this.tab.loadData(true);
                        this.window.close();
                    },
                });
            });
        }
    }

    /** Handles Events for the Work Toolbar
     *
     * @param id
     */
    private workToolbarHandler(id: string) {
        if (id == 'add') {
            const uuid = crypto.randomUUID();
            this.workGrid.addRow(uuid, ',,,/css/imgs/save.gif', 0, '', '', false);
        }
        if (id == 'delete') {
            this.deleteWorkItem();
        }
    }

    /** Delete a work item from the grid.
     * Will make sure that the user has selected one and confirm that they want to delete.
     */
    private deleteWorkItem(): void {
        const id = this.workGrid.getSelectedRowId();
        if (id == undefined) {
            dhtmlx.message({
                title: 'No Item',
                text: 'Please select a work item.',
                type: 'alert-warning',
            });
            return;
        }

        dhtmlx.confirm({
            type: 'confirm-warning',
            title: 'Confirm Delete',
            text: 'Delete this work item',
            ok: 'Delete Item',
            cancel: 'Cancel',
            callback: (result: boolean) => {
                if (result == true) {
                    this.workGrid.deleteRow(id);
                }
            },
        });
    }
}
